import { bootstrap } from "./boot/bootstrap";

void bootstrap().catch((error: unknown) => {
  console.error(error);
  const root = document.querySelector<HTMLElement>("#app");
  if (root) {
    root.innerHTML = `<main class="fatal-error"><p>Unable to start Starbound Home.</p><button type="button" onclick="location.reload()">RELOAD</button></main>`;
  }
});
